import React, { useEffect, useRef } from 'react';

const Html = ({ children, className = '' }) => {
  const ref = useRef();

  useEffect(() => {
    ref.current.innerHTML = children;
  }, [children]);

  return (
    <div
      className={`note-content ${className}`}
      ref={ref}
    ></div>
  );
};

export default Html;
